import {
  useSearchParam,
  useSearchParamsContext,
} from 'components/search/search.hooks';
import { DateTime } from 'luxon';
import { useEffect } from 'react';

export const useTimeZoneFilter = (startParamName, endParamName) => {
  const { setParam } = useSearchParamsContext();
  const { timeZone } = useSearchParam<DateTime>(startParamName);
  const zoneSearchParam = useSearchParam<string>(timeZone?.paramName);
  const zoneValue = zoneSearchParam?.value;

  useEffect(() => {
    if (timeZone && zoneValue) {
      setParam(startParamName, {
        toQueryString: (value: DateTime) =>
          value.setZone(zoneValue, { keepLocalTime: true }).toISO(),
      });
      setParam(endParamName, {
        toQueryString: (value: DateTime) =>
          value.setZone(zoneValue, { keepLocalTime: true }).toISO(),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeZone, zoneValue]);
};
